import { popoverAnatomy } from "@chakra-ui/anatomy";
import {
  createMultiStyleConfigHelpers,
  cssVar,
  defineStyle,
} from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(popoverAnatomy.keys);

const $popoverRadius = cssVar("popover-radius");

const baseStyleContent = defineStyle({
  [$popoverRadius.variable]: "radii.2xl",

  width: "400px",
  borderRadius: $popoverRadius.reference,
  _focus: {
    outline: 0,
    boxShadow: "none",
  },
});

const baseStyleBody = defineStyle({
  px: "0",
  pb: "0",
});

const baseStyleCloseButton = defineStyle({
  top: "4px",
  right: "4px",
  position: "absolute",
  _hover: {
    bg: "none",
  },
});

const baseStyleArrow = defineStyle({
  boxShadow: "none",
});

const baseStyle = definePartsStyle({
  content: baseStyleContent,
  body: baseStyleBody,
  closeButton: baseStyleCloseButton,
  arrow: baseStyleArrow,
});

export const Popover = defineMultiStyleConfig({
  baseStyle,
});
